import PropTypes from 'prop-types'; /* eslint-disable-line no-unused-vars */
import React from 'react';

import CallToAction from './CallToAction';
import Header from './Header';
import HeaderHeading from './HeaderHeading';

import HeaderList from './HeaderList';
import HeaderListHeading from './HeaderListHeading';
import HeaderListItem from './HeaderListItem';

import VideoList from './VideoList';
import VideoListHeader from './VideoListHeader';
import VideoListItems from './VideoListItems';
import VideoListItem from './VideoListItem';

function OnTheShow(props) {
  const {
    headerHeading,

    headerListHeading,
    headerListItems,
    shouldShowHeaderList,

    videoListOneItems,
    videoListOneHeading,
    videoListOneDescription,
    videoListOneHeadingURL,
    shouldShowVideoListOne,
    shouldShowVideoListOneHeader,

    videoListTwoItems,
    videoListTwoHeading,
    videoListTwoDescription,
    videoListTwoHeadingURL,
    shouldShowVideoListTwo,
    shouldShowVideoListTwoHeader,

    seeMoreContentURL,
    seeMoreContentText,
    maxHeight,
    showHeading,
  } = props;

  return (
    <div className="ontheshow" style={{ maxHeight }}>
      <Header>
        <HeaderHeading
          show={showHeading}
          text={headerHeading}
          url={seeMoreContentURL}
        />

        {shouldShowHeaderList && (
          <HeaderList>
            <HeaderListHeading
              text={headerListHeading}
            />

            {headerListItems.map((item) => (
              <HeaderListItem
                key={item.text}
                text={item.text}
                url={item.href}
              />
            ))}
          </HeaderList>
        )}
      </Header>

      {shouldShowVideoListOne && (
        <VideoList>
          <VideoListHeader
            show={shouldShowVideoListOneHeader}
            heading={videoListOneHeading}
            headingURL={videoListOneHeadingURL}
            description={videoListOneDescription}
          />

          <VideoListItems>
            {videoListOneItems.map((item) => (
              <VideoListItem
                key={item.videoTitle}
                imageURL={item.imageURL}
                imagePreviewURL={item.imagePreviewURL}
                imageAltText={item.imageAltText}
                videoURL={item.videoURL}
                videoDuration={item.videoDuration}
                videoTitle={item.videoTitle}
              />
            ))}
          </VideoListItems>
        </VideoList>
      )}

      {shouldShowVideoListTwo && (
        <VideoList>
          <VideoListHeader
            show={shouldShowVideoListTwoHeader}
            heading={videoListTwoHeading}
            headingURL={videoListTwoHeadingURL}
            description={videoListTwoDescription}
          />

          <VideoListItems>
            {videoListTwoItems.map((item) => (
              <VideoListItem
                key={item.videoTitle}
                imageURL={item.imageURL}
                imagePreviewURL={item.imagePreviewURL}
                imageAltText={item.imageAltText}
                videoURL={item.videoURL}
                videoDuration={item.videoDuration}
                videoTitle={item.videoTitle}
              />
            ))}
          </VideoListItems>
        </VideoList>
      )}

      <CallToAction
        text={seeMoreContentText}
        url={seeMoreContentURL}
      />
    </div>
  );
}

OnTheShow.propTypes = {
  headerHeading: PropTypes.string,

  headerListHeading: PropTypes.string,
  /* eslint-disable-next-line react/forbid-prop-types */
  headerListItems: PropTypes.array,
  shouldShowHeaderList: PropTypes.bool,

  /* eslint-disable-next-line react/forbid-prop-types */
  videoListOneItems: PropTypes.array,
  videoListOneHeading: PropTypes.string,
  videoListOneDescription: PropTypes.string,
  videoListOneHeadingURL: PropTypes.string,
  shouldShowVideoListOne: PropTypes.bool,
  shouldShowVideoListOneHeader: PropTypes.bool,

  /* eslint-disable-next-line react/forbid-prop-types */
  videoListTwoItems: PropTypes.array,
  videoListTwoHeading: PropTypes.string,
  videoListTwoDescription: PropTypes.string,
  videoListTwoHeadingURL: PropTypes.string,
  shouldShowVideoListTwo: PropTypes.bool,
  shouldShowVideoListTwoHeader: PropTypes.bool,

  seeMoreContentURL: PropTypes.string,
  seeMoreContentText: PropTypes.string,

  maxHeight: PropTypes.number,
  showHeading: PropTypes.bool,
};

OnTheShow.defaultProps = {
  headerHeading: '',

  headerListHeading: '',
  headerListItems: '',
  shouldShowHeaderList: false,

  videoListOneItems: [],
  videoListOneHeading: '',
  videoListOneDescription: '',
  videoListOneHeadingURL: '',
  shouldShowVideoListOne: false,
  shouldShowVideoListOneHeader: false,

  videoListTwoItems: [],
  videoListTwoHeading: '',
  videoListTwoDescription: '',
  videoListTwoHeadingURL: '',
  shouldShowVideoListTwo: false,
  shouldShowVideoListTwoHeader: false,

  seeMoreContentURL: '',
  seeMoreContentText: '',

  maxHeight: null,
  showHeading: true,
};

export default OnTheShow;
